import { render, staticRenderFns } from "./RelatorioDinamicoWindow.vue?vue&type=template&id=4b59abf4"
import script from "./RelatorioDinamicoWindow.vue?vue&type=script&lang=js"
export * from "./RelatorioDinamicoWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports